var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useAppSelector } from '@app/store';
// Exported for testing purposes
export var ModalFlash = function (_a) {
    var showModal = _a.showModal, closeModal = _a.closeModal, message = _a.message;
    return (React.createElement(Modal, { show: showModal, onHide: closeModal },
        React.createElement(Modal.Header, { closeButton: true },
            React.createElement(Modal.Title, null, "Wichtiger Hinweis")),
        React.createElement(Modal.Body, null, message),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { bsStyle: "secondary", onClick: closeModal }, "Schlie\u00DFen"))));
};
var FlashMessageModal = function () {
    var flash = useAppSelector(function (state) { return state.layout.flash.modal; });
    var _a = __read(useState(true), 2), showModal = _a[0], setShowModal = _a[1];
    var closeModal = function () { return setShowModal(false); };
    if (!flash) {
        return null;
    }
    return React.createElement(ModalFlash, { showModal: showModal, closeModal: closeModal, message: flash });
};
export default FlashMessageModal;
